<template>
    <div>
        <slot :letters="letters" :alphabets="alphabets" :activeLetters="activeLetters" :orchestraList="orchestraList" :swapView="swapView" :view="view"></slot>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref, watch } from 'vue';
import { getPeople } from '../services/inventory';
import { groupBy, sortBy } from 'lodash';

export default defineComponent({
    name: 'OrchestraRoster',
    setup(props) {
        const letters = ref([]);
        const activeLetters = ref([]);
        const orchestraList = ref([]);
        const view = ref('instrument');

        onMounted(async () => {
            let people = await getPeople();

            people = people.filter(person => {return person.attributes.custom}) // Must have custom attributes
            people = people.filter(person => {return person.attributes.custom.roster_display}) // Only people checked for ORchestra Display

            getNameViewData(people);
            getInstrumentViewData(people);
        })

       const alphabets = [
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z"
                ];

        const getNameViewData = (people) => {
            people = people.filter(person => {return person.lastName}) // Must have a lastName attribute

            const groupedByAlphabet = groupBy(people, person => person.lastName[0]);
            Object.keys(groupedByAlphabet).forEach(letter => {
                letters.value.push({
                    title: letter,
                    participantGroup: groupedByAlphabet[letter]
                });
            })

            letters.value = sortBy(letters.value, letter => {
                return letter.title;
            });

            activeLetters.value = Object.keys(groupedByAlphabet);
        }

        const getInstrumentViewData = (people) => {
            people = people.filter(person => {return person.attributes.custom}) // Must have custom attrs
            people = people.filter(person => {return person.attributes.custom.orchestra_group}) // Must have orchestra_group

            const groupedByOrchestra = groupBy(people, person => person.attributes.custom.orchestra_group);

            Object.keys(groupedByOrchestra).forEach(orchestra => {
                let orchestraObj = groupedByOrchestra[orchestra]

                orchestraList.value.push({
                    title: orchestra,
                    instruments: groupBy(orchestraObj, orchestraObj => orchestraObj.attributes.custom.instrument)
                });
            })

            orchestraList.value = sortBy(orchestraList.value, item => {
                return item.title;
            });
        }

        const swapView = (viewIn) => {
            view.value = viewIn;
        }

        return {
            letters,
            alphabets,
            activeLetters,
            orchestraList,
            swapView,
            view
        }
    },
});
</script>
